import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            language: "Language",
            title: "Plataforma DTS",
            username: "Username",
            password: "Password",
            login: "Login",
            register: "Register",
            back: "Back to Landing",
            version: "Version 3.0.0",

            dashboard: "Dashboard",
            manage: "Manage",
            settings: "Settings",
            exit: 'Exit',

            label_data_company: "Data Company",
            manage_user_type: "Manage User Type",
            label_user_type: "User Type",
            manage_tracking_device: "Manage Tracking Device",
            label_tracking_device: "Tracking Device",

            manage_fuel: "Manage Fuel",
            label_fuel: "Fuel",
            mobile_carrier: "Mobile Carrier",
            label_provider: "Provider",
            vehicle_model: "Vehicle Model",
            label_model: "Vehicle Model",
            vehicle_brand: "Vehicle Brand",
            label_brand: "Brand",
            vehicle_equipment_provider: "Equipment Provider",
            label_equipment_provider: "Provider",
            sim_card: "Sim Card",
            label_sim_card: "Sim Card",
            manage_company: "Manage Company",
            label_manage_company: "Manage Company",

            manage_type_fuel: "Manage Type Fuel",
            manage_vehicle_model: "Manage Vehicle Model",
            manage_mobile_carrier: "Manage Mobile Carrier",
            manage_brand: "Manage Brand",
            manage_equipment_provider: "Manage Equipment Provider",
            manage_trackin_device: "Manage Tracking Device",
            manage_users: "Manage Users",
            manage_mobile_operator: "Manage Mobile Operator",
            label_users: "Users",
            manage_group: "Manage Group",
            label_group: "Group",
            manage_sub_group: "Manage Sub Group",
            label_sub_group: "Sub Group",
            label_empresa: "Company",
            label_select_empresa: "Select Company",
            label_nombre_grupo: "Group Name",
            label_nombre_vendedor: "Name",
            manage_type_vehicle: "Manage Type Vehicle",
            label_type_vehicle: "Type Vehicle",
            label_modelo: "Vehicle Model",
            label_select_marca: "Select Brand",
            manage_voltaje_bateria: "Manage Battery Voltage",
            label_voltaje_bateria: "Battery Voltage",
            manage_traccion: "Manage Vehicle Traction",
            label_traccion: "Vehicle Traction",
            manage_vehicle: "Manage Vehicle",
            label_vehicle: "Vehicle",
            label_select_tipo_vehiculo: "Select Type Vehicle",
            label_nuevo_vehiculo: "New Vehicle",
            label_select_modelo: "Select Model",
            label_type_fuel: "Type Fuel",
            label_select_type_fuel: "Select Type Fuel",
            label_battery_voltage: "Battery Voltage",
            label_select_battery_voltage: "Select Battery Voltage",
            label_traction: "Traction",
            label_select_traction: "Select Traction",
            label_grupo: "Group",
            label_select_grupo: "Select Group",
            label_sub_grupo: "SubGroup",
            label_select_sub_grupo: "Select SubGroup",
            label_empresa_plataforma: "Company",
            label_select_empresa_plataforma: "Select Empresa",
            label_anio: "Year",
            label_editar_vehiculo: "Modify Vehicle",
            manage_secondary_client: "Manage Secondary Client",
            label_secondary_client: "Secondary Client",
            manage_sellers: "Manage Sellers",
            label_sellers: "Sellers",
            manage_currency: "Manage Currency",
            label_manage_currency: "Currency",
            label_select_document: "Select Document",

            code: "Code",
            enter_code: "Enter code",

            description: "Description",
            enter_description: "Enter description",
            enter_linea: "Enter Line",
            linea: "Line",
            carrier_provider: "Carrier Provider",

            note: "Note",
            enter_note: "Enter note",
            enter_order_number: "Order Number",

            id_equipo: "ID DEVICE",
            enter_id_equipo: "ENTER ID DEVICE",
            model: "MODEL",
            status: "STATUS",
            date_purchase: "DATE PURCHASE",
            device_provider: "DEVICE PROVIDER",
            label_nombre: "Name",
            enter_name: "ENTER NAME",

            label_last_name: "LAST NAME",
            enter_last_name: "ENTER LAST NAME",

            label_telefono: "PHONE NUMBER",
            enter_telefono: "ENTER PHONE NUMBER",

            status_disabled: "Disabled",
            status_enabled: "Enabled",

            licence_place: "Licence Plate",
            label_select_group: "Select Group",
            label_select_sub_group: "Select Sub Group",

            manage_installation: "MANAGE INSTALLATION",
            label_date_instalation: "DATE INSTALL",
            label_vehicle_tracker_installation: "VEHICLE TRACKER INSTALLATION",
            label_order_number_install: "ORDER NUMBER",
            label_date_unistall: "DATE UNINSTALL",
            label_order_number_uninstall: "ORDER NUMBER",
            label_instalacion_monto: "INSTALLATION AMOUNT",
            label_instalacion_monto_servicio: "SERVICE AMOUNT",

            manage_empresa_plataforma: "Manage Company Platform",
            label_cliente_empresa: "Client Company",
            label_manage_company_client: "Manage Client Company",

            label_administration: "Administration",
            label_select_provider: "Select Provider",
            label_currency: "Currency",
            label_select: "Select Option",
            label_error_empty_data: "Error, no data found",
            label_date_purchase: "Date purchase",
            label_alert_invalid_date: "Invalid date",

            manage_documents_concepts: "Manage Document Concepts",
            label_manage_document_concepts: "Manage Document Concepts",

            manage_account: "Manage Account",
            label_manage_account: "Manage Account",

            label_confirmar_password: "Confirm Password",
            label_tipo_servicio: "Type Service",
            label_telefono_empresa: "Company Phone",
            label_email_empresa: "Company Email",
            label_representante: "Delegate",
            label_telefono_representante: "Delegate Phone",
            label_email_representante: "Delegate Email",

            column_actions: "ACTIONS",
            column_advance: "ADVANZADO",
            column_code: "CODE",
            column_description: "DESCRIPTION",
            column_note: "NOTE",
            column_date_modify: "DATE MODIFY",
            column_enable: "ENABLED",
            column_linea: "LINE",
            column_iccid: "ICCID",
            column_idoperador: "column_idoperador",
            column_operador: "OPERATOR",
            column_id_equipo: "ID EQUIPO/ESN",
            column_model: "MODEL",
            column_status: "STATUS",
            column_date_purchase: "DATE PURCHASE",
            column_device_provider: "DEVICE PROVIDER",
            column_name: "NAME",
            column_phone_company: "PHONE COMPANY",
            column_phone_number: "PHONE NUMBER",
            column_email: "EMAIL",
            column_last_name: "LAST NAME",
            column_email_company: "EMAIL COMPANY",
            column_delegate: "DELEGATE",
            column_telephone_delegate: "PHONE DELEGATE",
            column_email_delegate: "EMAIL DELEGATE",
            column_usuario: "USER",
            title_edit_company: "EDIT COMPANY",
            column_company: "COMPANY",
            column_group: "GROUP",
            column_brand: "BRAND",
            column_placa: "PLATE",
            column_type_vehicle: "TYPE VEHICLE",
            column_type_fuel: "TYPE FUEL",
            column_voltaje_bateria: "BATTERY VOLTAGE",
            column_traction: "TRACTION",
            column_year: "YEAR",
            column_sub_group: "SUB GROUP",
            column_date_instalation: "DATE INSTALL",
            column_date_desinstalation: "DATE UNINSTALL",
            column_number_order_install: "NUMBER ORDER INSTALL",
            column_number_order_uninstall: "NUMBER ORDER UNINSTALL",
            column_especifica: "SPECIFIC",
            column_user: "USER",
            column_es_sub_cuenta: "SUB USER",
            column_symbol: "SYMBOL",
            column_currency: "CURRENCY",
            column_settings: "SETTINGS",
            column_equipos_activos: "ACTIVE DEVICES",
            column_equipos_desinstalados: "UNACTIVE DEVICES",
            column_precio_unitario: "UNIT PRICE",
            column_moneda: "CURRENCY",
            column_total_cobro: "TOTAL PAYMENT",
            column_dia_facturacion: "BILL DAY",
            column_monto_instalacion: "INSTALLATION AMOUNT",
            column_monto_servicio: "SERVICE AMOUNT",
            column_vendedor: "SELLER",
            column_cantidad_eventos: "EVENTS COUNT",

            label_yes: "Yes",
            label_no: "No",
            label_edit: "Edit",
            label_restore: "Restore",
            label_restore_password: "Restore Password",
            label_disable: "Disable",
            label_enable: "Enable",
            label_new: "NEW",
            label_back: "BACK",
            label_status: "STATUS",
            label_search: "SEARCH",
            label_update: "UPDATE",
            label_select_status: "Select status",
            label_select_carrier: "Select Carrier Operator",
            label_marca: "Brand",
            label_select_activo: "Activo/Vehicle",
            label_company: "Company",
            label_select_company: "Select Company",
            label_select_seller: "Select Seller",
            label_uninstall: "Uninstall",
            label_name_company: "Name Company",
            label_primary_color: "Main Color",
            label_secondary_color: "Secondary Color",
            label_third_color: "Third Color",
            label_menu_color: "Menu Color",
            label_select_color: "Select Color",
            label_manual_input: "Manual Input",
            label_from: "From",
            label_to: "To",
            label_delete: "Delete",
            label_password: "Password",
            label_enter_password: "Enter Password",
            label_seller: "Seller",
            label_date_begin: "DATE BEGIN",
            label_date_end: "DATE END",
            label_information: "INFO",
            label_numero_chasis: "Vehicle Identification Number (VIN)",
            label_numero_motor: "Engine number",
            label_cilindrada: "Displacement",
            label_capacidad_tanque: "Fuel Tank Capacity",
            label_capacidad_carga: "Load Capacity",
            label_capacidad_volumen: "Storage Capacity",
            label_name_activo: "Label/Name",
            label_date_install: "Date Install",
            label_date_uninstall: "Date Uninstall",
            label_order_install: "Order Install",
            label_order_uninstall: "Order Uninstall",
            label_device_provider: "Device Provider",
            label_model_device: "Device Model",
            label_sim_provider: "Sim Provider",
            label_subgrupo: "Subgroup",
            label_info_vehiculo: "Info Vehicle",
            label_tipo_vehiculo: "Type Vehicle",
            label_tipo_combustible: "Fuel",
            label_usuarios: "Users",
            label_recover_password: "Recover Password",
            label_select_tipo_usuario: "Select User Type",
            label_username: "Username",
            label_confirm_password: "Confirm Password",
            label_colors_blue: "Blue",
            label_colors_red: "Red",
            label_colors_green: "Green",
            label_colors_yellow: "Yellow",
            alert_you_can_only_upload_one_image: "You can only upload one image",
            label_color_marker: "Marker Color",
            label_performance_kml_ml: "Performance KML - ML",
            label_vehicle_color: "Vehicle Color",
            label_simbolo: "Symbol",
            label_enter_value: "Enter Value",
            label_date_expired: "Date Expired",
            label_nombre_sub_grupo: "Sub Group",
            label_name_group: "Group",
            label_must_select_group: "Must select group",
            label_must_select_sub_group: "Must select sub group",
            label_must_select_company: "Must select company",
            label_refresh: "Refresh",
            label_registrar_pago: "Register Payment",
            label_total: "Total",
            label_moneda: "Currency",
            label_monto: "Amount",
            label_select_estado: "Select Status",
            label_estado: "Status",
            label_codigo: "Code",
            label_nombre_encargado_cobranza: "Collection Manager Name",
            label_cargo_cobranza: "Collection Manager Position",
            label_telefono_cobranza: "Collection Manager Phone",
            label_email_cobranza: "Collection Manager Email",
            label_dia_facturacion: "Billing Day",
            label_atras: "Back",
            label_siguiente: "Next",
            label_crear_cuenta: "Create Account",
            label_usuario: "User",
            label_registrarse: "Register",
            label_guardar: "Save",
            label_dashboard_vacio: "No data found",

            placeholde_enter_nombre_empresa: "Enter Name Company",
            placeholder_enter_chasis: "Enter VIN",
            placeholder_enter_motor: "Enter Motor #",
            placeholder_enter_cilindrada: "Enter Displacement",
            placeholder_enter_capacidad_tanque: "Enter Fuel Tank Capacity",
            placeholder_enter_capacidad_carga: "Enter Load Capacity",
            placeholder_enter_capacidad_volumen: "Enter Storage Capacity",
            placeholder_enter_user: "Enter User",
            placeholder_enter_password: "Enter Password",
            placeholder_enter_confirm_password: "Enter Confirm Password",

            alert_enable_company: "You are about to enable the company, do you want to continue?",
            alert_disable_company: "You are about to disable the company, do you want to continue?",
            alert_enable_model_marca: "You are about to enable the brand, do you want to continue?",
            alert_disable_mobile_marca: "You are about to disable the brand, do you want to continue?",
            alert_enable_model_provider: "You are about to enable the mobile carrier, do you want to continue?",
            alert_disable_mobile_provider: "You are about to disable the mobile carrier, do you want to continue?",
            alert_enable_model_vehicle: "You are about to enable the vehicle model, do you want to continue?",
            alert_disable_model_vehicle: "You are about to disable the vehicle model, do you want to continue?",
            alert_disable_type_fuel: "You are about to disable the type of fuel, do you want to continue?",
            alert_disable_success: "Successfully disabled",
            alert_enable_success: "Successfully enabled",
            alert_disable_failed: "Failed to disable",
            alert_enable_failed: "Failed to enable",
            alert_disable_model_equipment_provider: "You are about to disable the equipment provider, do you want to continue?",
            alert_enable_model_equipment_provider: "You are about to enable the equipment provider, do you want to continue?",
            alert_disable_user: "You are about to disable the user, do you want to continue?",
            alert_enable_user: "You are about to enable the user, do you want to continue?",
            alert_enable_type_fuel: "You are about to enable the type of fuel, do you want to continue?",
            alert_update_success: "Successfully updated",
            alert_failed: "Failed",
            alert_created_success: "Successfully process",
            alert_must_enter_line: "Must enter line",
            alert_must_select_carrier: "Must select mobile provider",
            alert_must_select_tracking_device_provider: "Must select tracking device provider",
            alert_must_enter_device_id: "Must enter device id/ESN",
            alert_must_enter_model: "Must enter model",
            alert_must_enter_status: "Must enter status",
            alert_must_enter_purchase_date: "Must enter purchase date",
            alert_invalid_date: "Invalid date",
            alert_must_select_company: "Must select company",
            alert_must_enter_name: "Must enter name",
            alert_enable_model_grupo: "You are about to enable the group, do you want to continue?",
            alert_disable_model_grupo: "You are about to disable the group, do you want to continue?",
            alert_enable_model_sub_grupo: "You are about to enable the sub group, do you want to continue?",
            alert_disable_model_sub_grupo: "You are about to disable the sub group, do you want to continue?",
            alert_must_select_group: "Must select group",
            alert_disable_type_vehicle: "You are about to disable the type vehicle, do you want to continue?",
            alert_enable_type_vehicle: "You are about to enable the type vehicle, do you want to continue?",
            alert_disable_voltaje_bateria: "You are about to disable battery voltage, do you want to continue?",
            alert_enable_voltaje_bateria: "You are about to enable the battery voltage, do you want to continue?",
            alert_disable_vehiculo: "You are about to disable vehicle, do you want to continue?",
            alert_enable_vehiculo: "You are about to enable the vehicle, do you want to continue?",

            alert_disable_traccion: "You are about to disable vehicle traction, do you want to continue?",
            alert_enable_traccion: "You are about to enable vehicle traction, do you want to continue?",

            alert_disable_document_vehicle: "You are about to disable document, do you want to continue?",
            alert_enable_document_vehicle: "You are about to enable document traction, do you want to continue?",

            alert_disable_installation: "You are about to disable installation, do you want to continue?",

            alert_must_select_unit: "Must select Unit",

            alert_activo_equipo_no_desinstalado: "This vehicule and this id equipo does not have date uninstall",

            alert_successfully_proccess: "Successfully process",
            alert_could_not_process: "Could not process",

            alert_must_enter_password: "Must enter password",
            alert_must_enter_confirm_password: "Must enter confirm password",

            alert_disable_vendedor: "You are about to disable the seller, do you want to continue?",
            alert_enable_vendedor: "You are about to enable the seller, do you want to continue?",

            alert_must_enter_nombre_usuario: "Must enter username",
            alert_must_user_type: "Must select user type",
            alert_user_already_exists: "Username already exists",
            alert_passwords_dont_match: "Passwords don't match",

            alert_must_enter_licence_place: "Must enter licence plate",
            alert_must_enter_name_label: "Must enter name/label",
            alert_must_enter_type_vehicle: "Must select type vehicle",
            alert_must_select_brand_vehicle: "Must select vehicle brand",
            alert_must_select_vehicle_model: "Must select vehicle model",
            alert_must_enter_year: "Must enter year",
            alert_must_select_type_fuel: "Must select type fuel",
            alert_must_select_batery_voltage: "Must select battery voltage",
            alert_must_select_vehicle_traction: "Must select vehicle traction",
            alert_must_select_vehicle_group: "Must select vehicle group",
            alert_must_select_vehicle_sub_group: "Must select vehicle sub group",
            alert_must_select_marker_color: "Must select marker color",
            alert_must_select_vehicle_icon: "Must select vehicle icon",
            alert_disable_currency: "You are about to disable the currency, do you want to continue?",
            alert_enable_currency: "You are about to enable the currency, do you want to continue?",
            alert_must_select_currency: "Must select currency",
            alert_must_enter_value_currency: "Must enter currency value",

            alert_need_to_login_again: "You need to login again",
            alert_must_select_marca: "Must select brand",

            alert_must_choose_document: "Must select document",

            alert_types_allowed: 'Only JPG, PNG, and PDF files are allowed',
            alert_only_5_mb_allow: 'File size exceeds 5MB limit',

            alert_passwords_do_not_match: "Passwords do not match",

            alert_procesado_correctamente: "Process successful",
            alert_no_se_pudo_processar: "Could not process",
            alert_must_enter_amount: "Must Enter Amount",
            alert_must_select_estado_pago: "Must select payment status",
            alert_debe_ingresar_nombre_empresa: "Must enter name company",
            alert_debe_ingresar_telefono_empresa: "Must enter phone company",
            alert_debe_ingresar_email_empresa: "Must enter email company",
            alert_debe_seleccionar_timezone: "Must select timezone",
            alert_no_se_pudo_validar_nombre_empresa: "Could not validate company name",
            alert_nombre_empresa_ya_existe: "Company name already exists",
            alert_debe_ingresar_usuario: "Must enter username",
            alert_debe_ingresar_password: "Must enter password",
            alert_debe_ingresar_confirmar_password: "Must enter confirm password",
            alert_passwords_no_coinciden: "Passwords do not match",

            placeholder_enter_sub_group: "Enter Sub Group Name",

            title_manage_type_fuel: "MANAGE TYPE FUEL",
            title_manage_provider: "MANAGE MOBILE CARRIER",
            title_manage_vehicle_model: "MANAGE VEHICLE MODEL",
            title_manage_marca: "MANAGE BRAND",
            title_manage_equipment_provider: "MANAGE EQUIPMENT PROVIDER",
            title_manage_companies: "MANAGE COMPANIES",
            title_manage_users: "MANAGE USERS",
            title_manage_group: "MANAGE GROUP",
            title_manage_sub_group: "MANAGE SUB GROUP",
            title_manage_tipo_vehiculo: "MANGE TYPE VEHICLE",
            title_manage_battery_voltage: "MANAGE BATTERY VOLTAGE",
            title_manage_vehicle_traction: "MANAGE VEHICLE TRACTION",
            title_manage_installation: "MANAGE INSTALLATION",
            title_manage_installation_by_company: "MANAGE INSTALLATION BY COMPANY",
            title_manage_sim: "MANAGE SIM",
            title_manage_cliente_secundario: "MANAGE SECONDARY CLIENTE",
            title_restore_password: "RESTORE PASSWORD",
            title_manage_equipment_tracking: "MANAGE TRACKING DEVICE",
            title_manage_sellers: "MANAGE SELLERS",
            title_info_vehicle: "INFO VEHICLE",
            title_aditional_information: "ADITIONAL INFORMATION",
            title_aditional_custom: "ADITIONAL PERSONALIZATION",
            title_users_companies: "USUARIOS EMPRESA",
            title_manage_vehicle: "MANAGE VEHICLES",
            title_manage_currency: "MANAGE CURRENCY",
            title_manage_config_excel: "MANAGE EXCEL CONFIGURATION",
            title_manage_import: "MANAGE IMPORT",
            title_manage_vehicle_documents: "MANAGE DOCUMENTS VEHICLE",
            title_aditional_documents: "ADD DOCUMENTS",
            title_eventos: "EVENTS",
            title_registrar_empresa: "REGISTER COMPANY",
            title_datos_cobranza: "COLLECTION DATA",

            estado_pago_mora: "PENDING",
            estado_pago_pagado: "PAID",

            tipo_servicio_propio: "OWN",
            tipo_servicio_alquiler: "RENTAL",
        },
    },
    es: {
        translation: {
            language: "Idioma",
            title: "Plataforma DTS",
            username: "Usuario",
            password: "Contraseña",
            login: "Ingresar",
            register: "Registrarse",
            back: "Volver a Landing",
            version: "Versión 3.0.0",

            dashboard: "Dashboard",
            manage: "Administrar",
            settings: "Configuración",
            exit: 'Salir',

            label_data_company: "Datos de la empresa",
            manage_user_type: "Administrar Tipo Usuario",
            label_user_type: "Tipo Usuario",
            manage_tracking_device: "Administrar Dispositivo de Rastreo",
            label_tracking_device: "Dispositivo de Rastreo",

            manage_fuel: "Administrar Combustible",
            label_fuel: "Combustible",
            mobile_carrier: "Operador Móvil",
            label_provider: "Proveedor",
            vehicle_model: "Modelo de Vehículo",
            label_model: "Modelo",
            vehicle_brand: "Marca de Vehículo",
            label_brand: "Marca",
            vehicle_equipment_provider: "Proveedor de Equipo",
            label_equipment_provider: "Proveedor",
            sim_card: "Sim Card",
            label_sim_card: "Sim Card",
            manage_company: "Administrar Empresa",
            label_manage_company: "Administrar Empresa",

            manage_type_fuel: "Administrar Tipo Combustible",
            manage_vehicle_model: "Administrar Modelo de Vehículo",
            manage_mobile_carrier: "Administrar Operador Móvil",
            manage_brand: "Administrar Marca",
            manage_equipment_provider: "Administrar Proveedor de Equipo",
            manage_trackin_device: "Administrar Tracking Device",
            manage_users: "Administrar Usuarios",
            manage_mobile_operator: "Administrar Operador Movil",
            label_users: "Usuarios",
            manage_group: "Administrar Grupo",
            label_group: "Grupo",
            manage_sub_group: "Administrar Sub Grupo",
            label_sub_group: "Sub Grupo",
            label_empresa: "Empresa",
            label_select_empresa: "Seleccionar Empresa",
            label_nombre_grupo: "Nombre Grupo",
            label_nombre_vendedor: "Nombre",
            manage_type_vehicle: "Administrar Tipo Vehiculo",
            label_type_vehicle: "Tipo Vehiculo",
            label_modelo: "Modelo Vehiculo",
            code: "Código",
            enter_code: "Ingrese código",
            label_select_marca: "Seleccione Marca",
            manage_voltaje_bateria: "Administrar Voltaje Bateria",
            label_voltaje_bateria: "Voltaje Bateria",
            manage_traccion: "Administrar Traccion Vehiculo",
            label_traccion: "Traccion Vehiculo",
            manage_vehicle: "Administrar Vehiculos",
            label_vehicle: "Vehiculos",
            label_select_tipo_vehiculo: "Seleccione Tipo Vehiculo",
            label_nuevo_vehiculo: "Nuevo Vehiculo",
            label_select_modelo: "Seleccione Modelo",
            label_type_fuel: "Tipo Combustible",
            label_select_type_fuel: "Seleccione Tipo Combustible",
            label_battery_voltage: "Voltaje Bateria",
            label_select_battery_voltage: "Seleccione Voltaje Bateria",
            label_traction: "Traccion",
            label_select_traction: "Seleccione Traccion",
            label_grupo: "Grupo",
            label_select_grupo: "Seleccione Grupo",
            label_sub_grupo: "SubGrupo",
            label_select_sub_grupo: "Seleccione SubGrupo",
            label_empresa_plataforma: "Empresa",
            label_select_empresa_plataforma: "Seleccione Empresa",
            label_anio: "Año",
            label_editar_vehiculo: "Modificar Vehiculo",
            manage_secondary_client: "Administrar cliente secundario",
            label_secondary_client: "Cliente Secundario",
            manage_sellers: "Administrar Vendedores",
            label_sellers: "Vendedores",
            manage_currency: "Administrar Moneda",
            label_manage_currency: "Moneda",
            label_select_document: "Seleccione Documento",

            description: "Descripción",
            enter_description: "Ingrese descripción",
            enter_linea: "Ingrese Linea",
            linea: "Linea",
            carrier_provider: "Linea Telefonica",

            label_nombre: "Nombre",
            enter_name: "Ingrese Nombre",

            label_last_name: "Apellido",
            enter_last_name: "Ingrese Apellido",

            label_telefono: "Telefono",
            enter_telefono: "Ingrese Telefono",

            status_disabled: "Deshabilitado",
            status_enabled: "Habilitado",

            licence_place: "Placa",
            label_select_group: "Seleccione Grupo",
            label_select_sub_group: "Seleccione Sub Grupo",

            note: "Nota",
            enter_note: "Ingrese nota",
            enter_order_number: "Ingrese Numero Orden",

            id_equipo: "ID EQUIPO",
            enter_id_equipo: "INGRESE ID EQUIPO",
            model: "MODELO",
            status: "ESTADO",
            date_purchase: "FECHA ADQUISICION",
            device_provider: "PROVEEDOR DE DISPOSITIVO",
            manage_installation: "ADMINISTRAR INSTALACION",
            label_vehicle_tracker_installation: "INSTALACION",
            label_date_instalation: "FECHA INSTALACION",
            label_order_number_install: "NUMERO ORDEN",
            label_date_unistall: "FECHA DESINSTALACION",
            label_order_number_uninstall: "NUMERO ORDEN",
            label_instalacion_monto: "MONTO INSTALACION",
            label_instalacion_monto_servicio: "MONTO SERVICIO",

            manage_empresa_plataforma: "Administrar Empresa Plataforma",
            label_cliente_empresa: "Cliente Empresa",
            label_manage_company_client: "Administrar Cliente Empresa",

            label_administration: "Administración",
            label_select_provider: "Seleccione Proveedor",
            label_currency: "Moneda",
            label_select: "Seleccione Opcion",
            label_error_empty_data: "Error, no se encontraron datos",
            label_date_purchase: "Fecha Adquisicion",
            label_alert_invalid_date: "Fecha no valida",

            manage_documents_concepts: "Administrar Concepto Documentos",
            label_manage_document_concepts: "Administrar Concepto Documentos",

            manage_account: "Administrar Cuenta",
            label_manage_account: "Administrar Cuenta",

            label_confirmar_password: "Confirmar Password",
            label_tipo_servicio: "Tipo Servicio",
            label_telefono_empresa: "Telefono Empresa",
            label_email_empresa: "Email Empresa",
            label_representante: "Representante",
            label_telefono_representante: "Telefono Representante",
            label_email_representante: "Email Representante",

            column_actions: "ACCIONES",
            column_advance: "ADVANCE",
            column_code: "CODIGO",
            column_description: "DESCRIPCION",
            column_note: "NOTA",
            column_date_modify: "FECHA MODIFICACION",
            column_enable: "HABILITADO",
            column_linea: "LINEA",
            column_iccid: "ICCID",
            column_idoperador: "column_idoperador",
            column_operador: "OPERADOR",
            column_id_equipo: "DEVICE ID/ESN",
            column_model: "MODELO",
            column_status: "ESTADO",
            column_date_purchase: "FECHA ADQUISICION",
            column_device_provider: "PROVEEDOR DE DISPOSITIVO",
            column_name: "NOMBRE",
            column_phone_company: "TELEFONO EMPRESA",
            column_phone_number: "TELEFONO",
            column_email: "EMAIL",
            column_last_name: "APELLIDO",
            column_email_company: "EMAIL EMPRESA",
            column_delegate: "REPRESENTANTE",
            column_telephone_delegate: "TELEFONO REPRESENTANTE",
            column_email_delegate: "EMAIL REPRESENTANTE",
            column_usuario: "USUARIO",
            title_edit_company: "MODIFICAR EMPRESA",
            column_company: "EMPRESA PLATAFORMA",
            column_group: "GRUPO",
            column_brand: "MARCA",
            column_placa: "PLACA",
            column_type_vehicle: "TIPO VEHICULO",
            column_type_fuel: "TIPO COMBUSTIBLE",
            column_voltaje_bateria: "VOLTAJE BATERIA",
            column_traction: "TRACCION",
            column_year: "AÑO",
            column_sub_group: "SUB GRUPO",
            column_date_instalation: "FECHA INSTALACION",
            column_date_desinstalation: "FECHA DESINSTALACION",
            column_number_order_install: "NUMERO ORDEN INSTALACION",
            column_number_order_uninstall: "NUMERO ORDEN DESINSTALACION",
            column_especifica: "ESPECIFICA",
            column_user: "USUARIO",
            column_es_sub_cuenta: "ES SUB CUENTA",
            column_symbol: "SIMBOLO",
            column_currency: "MONEDA",
            column_settings: "CONFIGURACION",
            column_equipos_activos: "EQUIPOS ACTIVOS",
            column_equipos_desinstalados: "EQUIPOS DESACTIVADOS",
            column_precio_unitario: "PRECIO UNITARIO",
            column_moneda: "MONEDA",
            column_total_cobro: "TOTAL COBRO",
            column_dia_facturacion: "DIA FACTURACION",
            column_monto_instalacion: "MONTO INSTALACION",
            column_monto_servicio: "MONTO SERVICIO",
            column_vendedor: "VENDEDOR",
            column_cantidad_eventos: "CANTIDAD EVENTOS",

            label_yes: "Si",
            label_no: "No",
            label_edit: "Editar",
            label_restore: "Restaurar",
            label_restore_password: "Restaurar Contraseña",
            label_disable: "Deshabilitar",
            label_enable: "Habilitar",
            label_new: "NUEVO",
            label_back: "ATRAS",
            label_status: "ESTADO",
            label_search: "BUSCAR",
            label_update: "ACTUALIZAR",
            label_select_status: "Seleccione estado",
            label_select_carrier: "Seleccione Linea",
            label_marca: "Marca",
            label_select_activo: "ACTIVO",
            label_company: "Empresa",
            label_select_company: "Seleccione Empresa",
            label_select_seller: "Seleccione Vendedor",
            label_uninstall: "Desinstalar",
            label_name_company: "Nombre Empresa",
            label_primary_color: "Color principal",
            label_secondary_color: "Color secundario",
            label_third_color: "Color terciario",
            label_menu_color: "Color menu",
            label_select_color: "Seleccione Color",
            label_manual_input: "Ingreso Manual",
            label_from: "Origen",
            label_to: "Destino",
            label_delete: "Eliminar",
            label_password: "Contraseña",
            label_enter_password: "Ingrese Contraseña",
            label_seller: "Vendedor",
            label_date_begin: "FECHA INICIO",
            label_date_end: "FECHA FIN",
            label_information: "INFO",
            label_numero_chasis: "Numero Chasis",
            label_numero_motor: "Numero Motor",
            label_cilindrada: "Cilindrada",
            label_capacidad_tanque: "Capacidad Tanque",
            label_capacidad_carga: "Capacidad Carga",
            label_capacidad_volumen: "Capacidad Volumen",
            label_name_activo: "Nombre",
            label_date_install: "Fecha Instalacion",
            label_date_uninstall: "Fecha Desinstalacion",
            label_order_install: "Orden Instalacion",
            label_order_uninstall: "Orden Desinstalacion",
            label_device_provider: "Proveedor Equipo",
            label_model_device: "Modelo Equipo",
            label_sim_provider: "Proveedor Sim",
            label_subgrupo: "SubGrupo",
            label_info_vehiculo: "Info Vehiculo",
            label_tipo_vehiculo: "Tipo Vehiculo",
            label_tipo_combustible: "Tipo Combustible",
            label_usuarios: "Usuarios",
            label_recover_password: "Recuperar Contraseña",
            label_select_tipo_usuario: "Seleccione Tipo Usuario",
            label_username: "Nombre Usuario",
            label_confirm_password: "Confirmar Password",
            label_colors_blue: "Azul",
            label_colors_red: "Rojo",
            label_colors_green: "Verde",
            label_colors_yellow: "Amarillo",
            alert_you_can_only_upload_one_image: "Solo puedes subir una imagen",
            label_color_marker: "Color Marcador",
            label_performance_kml_ml: "Rendimiento KML - ML",
            label_vehicle_color: "Color Vehiculo",
            label_simbolo: "Simbolo",
            label_enter_value: "Ingrese Valor",
            label_date_expired: "Fecha Vencimiento",
            label_nombre_sub_grupo: "Sub Grupo",
            label_name_group: "Grupo",
            label_must_select_group: "Debe seleccionar grupo",
            label_must_select_sub_group: "Debe seleccionar sub grupo",
            label_must_select_company: "Debe seleccionar empresa",
            label_refresh: "Actualizar",
            label_registrar_pago: "Registrar Pago",
            label_total: "Total",
            label_moneda: "Moneda",
            label_monto: "Monto",
            label_select_estado: "Seleccione Estado",
            label_estado: "Estado",
            label_codigo: "Código",
            label_nombre_encargado_cobranza: "Nombre Encargado Cobranza",
            label_cargo_cobranza: "Cargo Cobranza",
            label_telefono_cobranza: "Telefono Cobranza",
            label_email_cobranza: "Email Cobranza",
            label_dia_facturacion: "Dia Facturacion",
            label_atras: "Atrás",
            label_siguiente: "Siguiente",
            label_crear_cuenta: "Crear Cuenta",
            label_usuario: "Usuario",
            label_registrarse: "Registrarse",
            label_guardar: "Guardar",
            label_dashboard_vacio: "No hay datos para mostrar en el Dashboard",

            placeholde_enter_nombre_empresa: "Ingrese Nombre Empresa",
            placeholder_enter_chasis: "Ingrese Chasis",
            placeholder_enter_motor: "Ingrese # Motor",
            placeholder_enter_cilindrada: "Ingrese Cilindrada",
            placeholder_enter_capacidad_tanque: "Ingrese Capacidad Tanque",
            placeholder_enter_capacidad_carga: "Ingrese Capacidad Carga",
            placeholder_enter_capacidad_volumen: "Ingrese Capacidad Volumen",
            placeholder_enter_user: "Ingrese usuario",
            placeholder_enter_password: "Ingrese password",
            placeholder_enter_confirm_password: "Ingrese cofirmar password",

            alert_enable_company: "Está a punto de habilitar la Empresa, desea continuar?",
            alert_disable_company: "Está a punto de deshabilitar la Empresa, desea continuar?",
            alert_enable_model_marca: "Está a punto de habilitar la marca, desea continuar?",
            alert_disable_mobile_marca: "Está a punto de deshabilitar la marca, desea continuar?",
            alert_enable_model_provider: "Está a punto de habilitar el operador móvil, desea continuar?",
            alert_disable_mobile_provider: "Está a punto de deshabilitar el operador móvil, desea continuar?",
            alert_enable_model_vehicle: "Está a punto de habilitar el modelo de vehículo, desea continuar?",
            alert_disable_model_vehicle: "Está a punto de deshabilitar el modelo de vehículo, desea continuar?",
            alert_disable_type_fuel: "Está a punto de deshabilitar el tipo de combustible, desea continuar?",
            alert_disable_success: "Se deshabilito correctamente",
            alert_enable_success: "Se habilito correctamente",
            alert_disable_failed: "Fallo al deshabilitar",
            alert_enable_failed: "Fallo al habilitar",
            alert_disable_model_equipment_provider: "Está a punto de deshabilitar proveedor de equipo, desea continuar?",
            alert_enable_model_equipment_provider: "Está a punto de habilitar proveedor de equipo, desea continuar?",
            alert_disable_user: "Está a punto de deshabilitar usuario, desea continuar?",
            alert_enable_user: "Está a punto de habilitar usuario, desea continuar?",
            alert_enable_type_fuel: "Está a punto de habilitar el tipo de combustible, desea continuar?",
            alert_update_success: "Se actualizo correctamente",
            alert_failed: "Fallo",
            alert_created_success: "Procesado correctamente",
            alert_must_enter_line: "Debe ingresar Linea",
            alert_must_select_carrier: "Debe seleccionar operadora telefonica",
            alert_must_select_tracking_device_provider: "Debe seleccionar proveedor de dispositivo rastreo",
            alert_must_enter_device_id: "Debe ingresar Id Equipo/ESN",
            alert_must_enter_model: "Debe ingresar modelo",
            alert_must_enter_status: "Debe ingresar estado",
            alert_must_enter_purchase_date: "Debe ingresar Fecha Adquisicion",
            alert_invalid_date: "Fecha Invalida",
            alert_must_select_company: "Debe seleccionar empresa",
            alert_must_enter_name: "Debe ingresar nombre",
            alert_enable_model_grupo: "Está a punto de deshabilitar el grupo, desea continuar?",
            alert_disable_model_grupo: "Está a punto de habilitar el grupo, desea continuar?",
            alert_enable_model_sub_grupo: "Está a punto de deshabilitar el sub grupo, desea continuar?",
            alert_disable_model_sub_grupo: "Está a punto de habilitar el sub grupo, desea continuar?",
            alert_must_select_group: "Debe seleccionar grupo",
            alert_disable_type_vehicle: "Está a punto de deshabilitar el tipo vehiculo, desea continuar?",
            alert_enable_type_vehicle: "Está a punto de habilitar el tipo vehiculo, desea continuar?",
            alert_disable_voltaje_bateria: "Está a punto de deshabilitar voltaje bateria, desea continuar?",
            alert_enable_voltaje_bateria: "Está a punto de habilitar el voltaje bateria, desea continuar?",
            alert_disable_vehiculo: "Está a punto de deshabilitar vehiculo, desea continuar?",
            alert_enable_vehiculo: "Está a punto de habilitar el vehiculo, desea continuar?",

            alert_disable_traccion: "Está a punto de deshabilitar traccion, desea continuar?",
            alert_enable_traccion: "Está a punto de habilitar el traccion, desea continuar?",

            alert_disable_document_vehicle: "Está a punto de deshabilitar documento, desea continuar?",
            alert_enable_document_vehicle: "Está a punto de habilitar el documento, desea continuar?",


            alert_disable_installation: "Está a punto de deshabilitar instalacion, desea continuar?",

            alert_must_select_unit: "Debe seleccionar Unidad/Activo",

            alert_activo_equipo_no_desinstalado: "Esta unidad con este equipo no tiene fecha desinstalacion",

            alert_successfully_proccess: "Procesado correctamente",
            alert_could_not_process: "No se pudo procesar",

            alert_must_enter_password: "Debe ingresar contraseña",
            alert_must_enter_confirm_password: "Debe ingresar confirmar contraseña",

            alert_disable_vendedor: "Está a punto de deshabilitar el vendedor, desea continuar?",
            alert_enable_vendedor: "Está a punto de habilitar el vendedor, desea continuar?",

            alert_must_enter_nombre_usuario: "Ingrese nombre usuario",
            alert_must_user_type: "Seleccione tipo usuario",
            alert_user_already_exists: "Nombre usuario ya existe",
            alert_passwords_dont_match: "Passwords no coinciden",

            alert_must_enter_licence_place: "Debe ingresar placa",
            alert_must_enter_name_label: "Debe ingresar nombre/label",
            alert_must_enter_type_vehicle: "Debe ingresar seleccionar Tipo Vehiculo",
            alert_must_select_brand_vehicle: "Debe seleccionar Marca Vehiculo",
            alert_must_select_vehicle_model: "Debe seleccionar Modelo Vehiculo",
            alert_must_enter_year: "Debe ingresar Año",
            alert_must_select_type_fuel: "Debe seleccionar Tipo Combustible",
            alert_must_select_batery_voltage: "Debe seleccionar Voltaje Bateria",
            alert_must_select_vehicle_traction: "Debe seleccionar Traccion",
            alert_must_select_vehicle_group: "Debe seleccionar Grupo Vehiculo",
            alert_must_select_vehicle_sub_group: "Debe seleccionar SubGrupo Vehiculo",
            alert_must_select_marker_color: "Debe seleccionar color marker",
            alert_must_select_vehicle_icon: "Debe seleccionar icono vehiculo",
            alert_disable_currency: "Está a punto de deshabilitar la moneda, desea continuar?",
            alert_enable_currency: "Está a punto de habilitar la moneda, desea continuar?",
            alert_must_select_currency: "Debe seleccionar moneda",
            alert_must_enter_value_currency: "Debe ingresar valor moneda",

            alert_need_to_login_again: "Necesita volver a iniciar sesión",
            alert_must_select_marca: "Debe seleccionar Marca",

            alert_must_choose_document: "Debe seleccionar documento",

            alert_types_allowed: 'Solo JPG, PNG, and PDF files son permitidos',

            alert_only_5_mb_allow: 'File excede los 5MB permitidos',

            alert_passwords_do_not_match: "Passwords no coinciden",

            alert_procesado_correctamente: "Procesado correctamente",
            alert_no_se_pudo_processar: "No se pudo procesar",
            alert_must_enter_amount: "Debe ingresar monto",
            alert_must_select_estado_pago: "Debe seleccionar estado pago",
            alert_debe_ingresar_nombre_empresa: "Debe ingresar nombre empresa",
            alert_debe_ingresar_telefono_empresa: "Debe ingresar telefono empresa",
            alert_debe_ingresar_email_empresa: "Debe ingresar email empresa",
            alert_debe_seleccionar_timezone: "Debe seleccionar zona horaria",
            alert_no_se_pudo_validar_nombre_empresa: "No se pudo validar nombre empresa",
            alert_nombre_empresa_ya_existe: "Nombre empresa ya existe",
            alert_debe_ingresar_usuario: "Debe ingresar usuario",
            alert_debe_ingresar_password: "Debe ingresar password",
            alert_debe_ingresar_confirmar_password: "Debe ingresar confirmar password",
            alert_passwords_no_coinciden: "Passwords no coinciden",

            placeholder_enter_sub_group: "Ingrese Nombre Sub Grupo",

            title_manage_type_fuel: "ADMINISTRAR TIPO COMBUSTIBLE",
            title_manage_provider: "ADMINISTRAR OPERADOR MOVIL",
            title_manage_vehicle_model: "ADMINISTRAR MODELO DE VEHICULO",
            title_manage_marca: "ADMINISTRAR MARCA",
            title_manage_equipment_provider: "ADMINISTRAR PROVEEDORES DE EQUIPO",
            title_manage_companies: "ADMINISTRAR EMPRESAS",
            title_manage_users: "ADMINISTRAR USUARIOS",
            title_manage_group: "ADMINISTRAR GRUPO",
            title_manage_sub_group: "ADMINISTRAR SUB GRUPO",
            title_manage_tipo_vehiculo: "ADMINISTRAR TIPO VEHICULO",
            title_manage_battery_voltage: "ADMINISTRAR VOLTAJE BATERIA",
            title_manage_vehicle_traction: "ADMINISTRAR TRACCION VEHICULO",
            title_manage_installation: "ADMINISTRAR INSTALACION",
            title_manage_installation_by_company: "ADMINISTRAR INSTALACION POR EMPRESA",
            title_manage_sim: "ADMINISTRAR SIM",
            title_manage_cliente_secundario: "ADMINISTRAR CLIENTE SECUNDARIO",
            title_restore_password: "RESTAURAR CONTRASEÑA",
            title_manage_equipment_tracking: "ADMINISTRAR EQUIPO DE RASTREO",
            title_manage_sellers: "ADMINISTRAR VENDEDORES",
            title_info_vehicle: "INFO VEHICULO",
            title_aditional_information: "INFORMACION ADICIONAL",
            title_aditional_custom: "PERSONALIZACION ADICIONAL",
            title_users_companies: "USERS COMPANY",
            title_manage_vehicle: "ADMINISTRAR VEHICULO",
            title_manage_currency: "ADMINISTRAR MONEDA",
            title_manage_config_excel: "ADMINISTRAR CONFIGURACION EXCEL",
            title_manage_import: "ADMINISTRAR IMPORTACION",
            title_manage_vehicle_documents: "ADMINISTRAR DOCUMENTOS VEHICULO",
            title_aditional_documents: "AGREGAR DOCUMENTOS",
            title_eventos: "LISTA EVENTOS",
            title_registrar_empresa: "REGISTRAR EMPRESA",
            title_datos_cobranza: "DATOS DE COBRANZA",

            estado_pago_mora: "MORA",
            estado_pago_pagado: "PAGADO",

            tipo_servicio_propio: "PROPIO",
            tipo_servicio_alquiler: "RENTADO",
        },
    },
    pt: {
        translation: {
            language: "Idioma",
            title: "Plataforma DTS",
            username: "Usuário",
            password: "Senha",
            login: "Entrar",
            register: "Registrar",
            back: "Voltar ao Início",
            version: "Versão 3.0.0",

            dashboard: "Painel",
            manage: "Gerenciar",
            settings: "Configurações",
            exit: "Sair",

            label_data_company: "Dados da Empresa",
            manage_user_type: "Gerenciar Tipo de Usuário",
            label_user_type: "Tipo de Usuário",
            manage_tracking_device: "Gerenciar Dispositivo de Rastreamento",
            label_tracking_device: "Dispositivo de Rastreamento",

            manage_fuel: "Gerenciar Combustível",
            label_fuel: "Combustível",
            mobile_carrier: "Operadora Móvel",
            label_provider: "Fornecedor",
            vehicle_model: "Modelo de Veículo",
            label_model: "Modelo de Veículo",
            vehicle_brand: "Marca de Veículo",
            label_brand: "Marca",
            vehicle_equipment_provider: "Fornecedor de Equipamento",
            label_equipment_provider: "Fornecedor",
            sim_card: "Cartão SIM",
            label_sim_card: "Cartão SIM",
            manage_company: "Gerenciar Empresa",
            label_manage_company: "Gerenciar Empresa",

            manage_type_fuel: "Gerenciar Tipo de Combustível",
            manage_vehicle_model: "Gerenciar Modelo de Veículo",
            manage_mobile_carrier: "Gerenciar Operadora Móvel",
            manage_brand: "Gerenciar Marca",
            manage_equipment_provider: "Gerenciar Fornecedor de Equipamento",
            manage_users: "Gerenciar Usuários",
            manage_mobile_operator: "Gerenciar Operadora Móvel",
            label_users: "Usuários",
            manage_group: "Gerenciar Grupo",
            label_group: "Grupo",
            manage_sub_group: "Gerenciar Subgrupo",
            label_sub_group: "Subgrupo",
            label_empresa: "Empresa",
            label_select_empresa: "Selecione a Empresa",
            label_nombre_grupo: "Nome do Grupo",
            label_nombre_vendedor: "Nome",
            manage_type_vehicle: "Gerenciar Tipo de Veículo",
            label_type_vehicle: "Tipo de Veículo",
            label_modelo: "Modelo de Veículo",
            label_select_marca: "Selecione Marca",
            manage_voltaje_bateria: "Gerenciar Tensão da Bateria",
            label_voltaje_bateria: "Tensão da Bateria",
            manage_traccion: "Gerenciar Tração do Veículo",
            label_traccion: "Tração do Veículo",
            manage_vehicle: "Gerenciar Veículo",
            label_vehicle: "Veículo",
            label_select_tipo_vehiculo: "Selecione Tipo de Veículo",
            label_nuevo_vehiculo: "Novo Veículo",
            label_select_modelo: "Selecione Modelo",
            label_type_fuel: "Tipo de Combustível",
            label_select_type_fuel: "Selecione Tipo de Combustível",
            label_battery_voltage: "Tensão da Bateria",
            label_select_battery_voltage: "Selecione Tensão da Bateria",
            label_traction: "Tração",
            label_select_traction: "Selecione Tração",
            label_grupo: "Grupo",
            label_select_grupo: "Selecione Grupo",
            label_sub_grupo: "Subgrupo",
            label_select_sub_grupo: "Selecione Subgrupo",
            label_empresa_plataforma: "Empresa",
            label_select_empresa_plataforma: "Selecione Empresa",
            label_anio: "Ano",
            label_editar_vehiculo: "Modificar Veículo",
            manage_secondary_client: "Gerenciar Cliente Secundário",
            label_secondary_client: "Cliente Secundário",
            manage_sellers: "Gerenciar Vendedores",
            label_sellers: "Vendedores",
            manage_currency: "Gerenciar Moeda",
            label_manage_currency: "Moeda",
            label_select_document: "Selecione Documento",

            code: "Código",
            enter_code: "Digite o Código",

            description: "Descrição",
            enter_description: "Digite a Descrição",
            enter_linea: "Digite a Linha",
            linea: "Linha",
            carrier_provider: "Operadora",

            note: "Observação",
            enter_note: "Digite uma Observação",
            enter_order_number: "Número do Pedido",

            id_equipo: "ID DO DISPOSITIVO",
            enter_id_equipo: "Digite o ID do Dispositivo",
            model: "Modelo",
            status: "Status",
            date_purchase: "Data da Compra",
            device_provider: "Fornecedor do Dispositivo",
            label_nombre: "Nome",
            enter_name: "Digite o Nome",

            label_last_name: "Sobrenome",
            enter_last_name: "Digite o Sobrenome",

            label_telefono: "Número de Telefone",
            enter_telefono: "Digite o Telefone",

            status_disabled: "Desativado",
            status_enabled: "Ativado",

            licence_place: "Placa",
            label_select_group: "Selecione Grupo",
            label_select_sub_group: "Selecione Subgrupo",

            manage_installation: "Gerenciar Instalação",
            label_date_instalation: "Data de Instalação",
            label_vehicle_tracker_installation: "Instalação do Rastreador",
            label_order_number_install: "Número do Pedido de Instalação",
            label_date_unistall: "Data de Desinstalação",
            label_order_number_uninstall: "Número do Pedido de Desinstalação",
            label_instalacion_monto: "Valor da Instalação",
            label_instalacion_monto_servicio: "Valor da Serviço",

            manage_empresa_plataforma: "Gerenciar Plataforma da Empresa",
            label_cliente_empresa: "Empresa Cliente",
            label_manage_company_client: "Gerenciar Cliente da Empresa",

            label_administration: "Administração",
            label_select_provider: "Selecione Fornecedor",
            label_currency: "Moeda",
            label_select: "Selecionar Opção",
            label_error_empty_data: "Erro, dados não encontrados",
            label_date_purchase: "Data da Compra",
            label_alert_invalid_date: "Data Inválida",

            manage_documents_concepts: "Gerenciar Conceitos de Documentos",
            label_manage_document_concepts: "Gerenciar Conceitos de Documentos",

            manage_account: "Gerenciar Conta",
            label_manage_account: "Gerenciar Conta",

            label_confirmar_password: "Confirmar Senha",
            label_tipo_servicio: "Tipo de Serviço",
            label_telefono_empresa: "Telefone da Empresa",
            label_email_empresa: "Email da Empresa",
            label_representante: "Representante",
            label_telefono_representante: "Telefone do Representante",
            label_email_representante: "Email do Representante",

            column_actions: "AÇÕES",
            column_advance: "AVANÇADO",
            column_code: "CÓDIGO",
            column_description: "DESCRIÇÃO",
            column_note: "OBSERVAÇÕES",
            column_date_modify: "DATA DA MODIFICAÇÃO",
            column_enable: "ATIVADO",
            column_linea: "LINHA",
            column_iccid: "ICCID",
            column_idoperador: "column_idoperador",
            column_operador: "OPERADORA",
            column_id_equipo: "ID EQUIPAMENTO/ESN",
            column_model: "MODELO",
            column_status: "STATUS",
            column_date_purchase: "DATA DA COMPRA",
            column_device_provider: "FORNECEDOR DO DISPOSITIVO",
            column_name: "NOME",
            column_phone_company: "TELEFONE DA EMPRESA",
            column_phone_number: "NÚMERO DE TELEFONE",
            column_email: "EMAIL",
            column_last_name: "SOBRENOME",
            column_email_company: "EMAIL DA EMPRESA",
            column_delegate: "DELEGADO",
            column_telephone_delegate: "TELEFONE DO DELEGADO",
            column_email_delegate: "EMAIL DO DELEGADO",
            column_usuario: "USUÁRIO",
            title_edit_company: "EDITAR EMPRESA",
            column_company: "EMPRESA",
            column_group: "GRUPO",
            column_brand: "MARCA",
            column_placa: "PLACA",
            column_type_vehicle: "TIPO DE VEÍCULO",
            column_type_fuel: "TIPO DE COMBUSTÍVEL",
            column_voltaje_bateria: "TENSÃO DA BATERIA",
            column_traction: "TRAÇÃO",
            column_year: "ANO",
            column_sub_group: "SUBGRUPO",
            column_date_instalation: "DATA DA INSTALAÇÃO",
            column_date_desinstalation: "DATA DA DESINSTALAÇÃO",
            column_number_order_install: "NÚMERO DO PEDIDO DE INSTALAÇÃO",
            column_number_order_uninstall: "NÚMERO DO PEDIDO DE DESINSTALAÇÃO",
            column_especifica: "ESPECÍFICO",
            column_user: "USUÁRIO",
            column_es_sub_cuenta: "SUB-USUÁRIO",
            column_symbol: "SÍMBOLO",
            column_currency: "MOEDA",
            column_settings: "CONFIGURAÇÕES",
            column_equipos_activos: "EQUIPAMENTOS ATIVOS",
            column_equipos_desinstalados: "EQUIPAMENTOS DESATIVADOS",
            column_precio_unitario: "PREÇO UNITÁRIO",
            column_moneda: "MOEDA",
            column_total_cobro: "TOTAL A COBRAR",
            column_dia_facturacion: "DIA DE FATURAMENTO",
            column_monto_instalacion: "VALOR DA INSTALAÇÃO",
            column_monto_servicio: "VALOR DO SERVIÇO",
            column_vendedor: "VENDEDOR",
            column_cantidad_eventos: "QUANTIDADE DE EVENTOS",

            label_yes: "Sim",
            label_no: "Não",
            label_edit: "Editar",
            label_restore: "Restaurar",
            label_restore_password: "Restaurar Senha",
            label_disable: "Desativar",
            label_enable: "Ativar",
            label_new: "NOVO",
            label_back: "VOLTA",
            label_status: "STATUS",
            label_search: "PESQUISAR",
            label_update: "ATUALIZAR",
            label_select_status: "Selecionar Status",
            label_select_carrier: "Selecionar Operadora",
            label_marca: "Marca",
            label_select_activo: "Ativo/Veículo",
            label_company: "Empresa",
            label_select_company: "Selecionar Empresa",
            label_select_seller: "Selecionar Vendedor",
            label_uninstall: "Desinstalar",
            label_name_company: "Nome da Empresa",
            label_primary_color: "Cor Principal",
            label_secondary_color: "Cor Secundária",
            label_third_color: "Terceira Cor",
            label_menu_color: "Cor do Menu",
            label_select_color: "Selecionar Cor",
            label_manual_input: "Entrada Manual",
            label_from: "De",
            label_to: "Até",
            label_delete: "Excluir",
            label_password: "Senha",
            label_enter_password: "Digite a Senha",
            label_seller: "Vendedor",
            label_date_begin: "DATA INICIAL",
            label_date_end: "DATA FINAL",
            label_information: "INFORMAÇÃO",
            label_numero_chasis: "Número do Chassi (VIN)",
            label_numero_motor: "Número do Motor",
            label_cilindrada: "Cilindrada",
            label_capacidad_tanque: "Capacidade do Tanque de Combustível",
            label_capacidad_carga: "Capacidade de Carga",
            label_capacidad_volumen: "Capacidade de Armazenamento",
            label_name_activo: "Etiqueta/Nome",
            label_date_install: "Data da Instalação",
            label_date_uninstall: "Data da Desinstalação",
            label_order_install: "Pedido de Instalação",
            label_order_uninstall: "Pedido de Desinstalação",
            label_device_provider: "Fornecedor do Dispositivo",
            label_model_device: "Modelo do Dispositivo",
            label_sim_provider: "Fornecedor do SIM",
            label_subgrupo: "Subgrupo",
            label_info_vehiculo: "Informações do Veículo",
            label_tipo_vehiculo: "Tipo de Veículo",
            label_tipo_combustible: "Combustível",
            label_usuarios: "Usuários",
            label_recover_password: "Recuperar Senha",
            label_select_tipo_usuario: "Selecionar Tipo de Usuário",
            label_username: "Nome de Usuário",
            label_confirm_password: "Confirmar Senha",
            label_colors_blue: "Azul",
            label_colors_red: "Vermelho",
            label_colors_green: "Verde",
            label_colors_yellow: "Amarelo",
            alert_you_can_only_upload_one_image: "Você só pode fazer upload de uma imagem",
            label_color_marker: "Cor do Marcador",
            label_performance_kml_ml: "Desempenho KML - ML",
            label_vehicle_color: "Cor do Veículo",
            label_simbolo: "Símbolo",
            label_enter_value: "Digite o Valor",
            label_date_expired: "Data de Expiração",
            label_nombre_sub_grupo: "Subgrupo",
            label_name_group: "Grupo",
            label_must_select_group: "Você deve selecionar um grupo",
            label_must_select_sub_group: "Você deve selecionar um subgrupo",
            label_must_select_company: "Você deve selecionar uma empresa",
            label_refresh: "Atualizar",
            label_registrar_pago: "Registrar Pagamento",
            label_total: "Total",
            label_moneda: "Moeda",
            label_monto: "Valor",
            label_select_estado: "Selecione o status",
            label_estado: "Status",
            label_codigo: "Código",
            label_nombre_encargado_cobranza: "Nome do Responsável pela Cobrança",
            label_cargo_cobranza: "Cargo do Responsável pela Cobrança",
            label_telefono_cobranza: "Telefone do Responsável pela Cobrança",
            label_email_cobranza: "Email do Responsável pela Cobrança",
            label_dia_facturacion: "Dia de Faturamento",
            label_atras: "Voltar",
            label_siguiente: "Próximo",
            label_crear_cuenta: "Criar Conta",
            label_usuario: "Usuário",
            label_registrarse: "Registrar-se",
            label_guardar: "Salvar",
            label_dashboard_vacio: "Nenhum dado encontrado",

            placeholde_enter_nombre_empresa: "Digite o Nome da Empresa",
            placeholder_enter_chasis: "Digite o Número do Chassi",
            placeholder_enter_motor: "Digite o Número do Motor",
            placeholder_enter_cilindrada: "Digite a Cilindrada",
            placeholder_enter_capacidad_tanque: "Digite a Capacidade do Tanque de Combustível",
            placeholder_enter_capacidad_carga: "Digite a Capacidade de Carga",
            placeholder_enter_capacidad_volumen: "Digite a Capacidade de Armazenamento",
            placeholder_enter_user: "Digite o Usuário",
            placeholder_enter_password: "Digite a Senha",
            placeholder_enter_confirm_password: "Digite a Confirmação da Senha",

            alert_enable_company: "Você está prestes a ativar a empresa, deseja continuar?",
            alert_disable_company: "Você está prestes a desativar a empresa, deseja continuar?",
            alert_enable_model_marca: "Você está prestes a ativar a marca, deseja continuar?",
            alert_disable_mobile_marca: "Você está prestes a desativar a marca, deseja continuar?",
            alert_enable_model_provider: "Você está prestes a ativar a operadora, deseja continuar?",
            alert_disable_mobile_provider: "Você está prestes a desativar a operadora, deseja continuar?",
            alert_enable_model_vehicle: "Você está prestes a ativar o modelo de veículo, deseja continuar?",
            alert_disable_model_vehicle: "Você está prestes a desativar o modelo de veículo, deseja continuar?",
            alert_disable_type_fuel: "Você está prestes a desativar o tipo de combustível, deseja continuar?",
            alert_disable_success: "Desativado com sucesso",
            alert_enable_success: "Ativado com sucesso",
            alert_disable_failed: "Falha ao desativar",
            alert_enable_failed: "Falha ao ativar",
            alert_disable_model_equipment_provider: "Você está prestes a desativar o equipamento, deseja continuar?",
            alert_enable_model_equipment_provider: "Você está prestes a ativar o equipamento, deseja continuar?",
            alert_disable_user: "Você está prestes a desativar o usuário, deseja continuar?",
            alert_enable_user: "Você está prestes a ativar o usuário, deseja continuar?",
            alert_enable_type_fuel: "Você está prestes a ativar o tipo de combustível, deseja continuar?",
            alert_update_success: "Atualizado com sucesso",
            alert_failed: "Falha",
            alert_created_success: "Processado com sucesso",
            alert_must_enter_line: "É necessário inserir a linha",
            alert_must_select_carrier: "É necessário selecionar a operadora",
            alert_must_select_tracking_device_provider: "É necessário selecionar o fornecedor do dispositivo de rastreamento",
            alert_must_enter_device_id: "É necessário inserir o ID do dispositivo/ESN",
            alert_must_enter_model: "É necessário inserir o modelo",
            alert_must_enter_status: "É necessário inserir o status",
            alert_must_enter_purchase_date: "É necessário inserir a data da compra",
            alert_invalid_date: "Data inválida",
            alert_must_select_company: "É necessário selecionar a empresa",
            alert_must_enter_name: "É necessário inserir o nome",
            alert_enable_model_grupo: "Você está prestes a ativar o grupo, deseja continuar?",
            alert_disable_model_grupo: "Você está prestes a desativar o grupo, deseja continuar?",
            alert_enable_model_sub_grupo: "Você está prestes a ativar o subgrupo, deseja continuar?",
            alert_disable_model_sub_grupo: "Você está prestes a desativar o subgrupo, deseja continuar?",
            alert_must_select_group: "É necessário selecionar um grupo",
            alert_disable_type_vehicle: "Você está prestes a desativar o tipo de veículo, deseja continuar?",
            alert_enable_type_vehicle: "Você está prestes a ativar o tipo de veículo, deseja continuar?",
            alert_disable_voltaje_bateria: "Você está prestes a desativar a voltagem da bateria, deseja continuar?",
            alert_enable_voltaje_bateria: "Você está prestes a ativar a voltagem da bateria, deseja continuar?",
            alert_disable_vehiculo: "Você está prestes a desativar o veículo, deseja continuar?",
            alert_enable_vehiculo: "Você está prestes a ativar o veículo, deseja continuar?",

            alert_disable_traccion: "Você está prestes a desativar a tração do veículo, deseja continuar?",
            alert_enable_traccion: "Você está prestes a ativar a tração do veículo, deseja continuar?",

            alert_disable_document_vehicle: "Você está prestes a desativar o documento, deseja continuar?",
            alert_enable_document_vehicle: "Você está prestes a ativar o documento, deseja continuar?",

            alert_disable_installation: "Você está prestes a desativar a instalação, deseja continuar?",

            alert_must_select_unit: "Deve selecionar uma unidade",

            alert_activo_equipo_no_desinstalado: "Este veículo e este ID de equipamento não possuem data de desinstalação",

            alert_successfully_proccess: "Processado com sucesso",
            alert_could_not_process: "Não foi possível processar",

            alert_must_enter_password: "Deve inserir a senha",
            alert_must_enter_confirm_password: "Deve confirmar a senha",

            alert_disable_vendedor: "Você está prestes a desativar o vendedor, deseja continuar?",
            alert_enable_vendedor: "Você está prestes a ativar o vendedor, deseja continuar?",

            alert_must_enter_nombre_usuario: "Deve inserir o nome de usuário",
            alert_must_user_type: "Deve selecionar o tipo de usuário",
            alert_user_already_exists: "O nome de usuário já existe",
            alert_passwords_dont_match: "As senhas não coincidem",

            alert_must_enter_licence_place: "Deve inserir a placa",
            alert_must_enter_name_label: "Deve inserir o nome/rótulo",
            alert_must_enter_type_vehicle: "Deve selecionar o tipo de veículo",
            alert_must_select_brand_vehicle: "Deve selecionar a marca do veículo",
            alert_must_select_vehicle_model: "Deve selecionar o modelo do veículo",
            alert_must_enter_year: "Deve inserir o ano",
            alert_must_select_type_fuel: "Deve selecionar o tipo de combustível",
            alert_must_select_batery_voltage: "Deve selecionar a voltagem da bateria",
            alert_must_select_vehicle_traction: "Deve selecionar a tração do veículo",
            alert_must_select_vehicle_group: "Deve selecionar o grupo do veículo",
            alert_must_select_vehicle_sub_group: "Deve selecionar o subgrupo do veículo",
            alert_must_select_marker_color: "Deve selecionar a cor do marcador",
            alert_must_select_vehicle_icon: "Deve selecionar o ícone do veículo",

            alert_disable_currency: "Você está prestes a desativar a moeda, deseja continuar?",
            alert_enable_currency: "Você está prestes a ativar a moeda, deseja continuar?",
            alert_must_select_currency: "Deve selecionar uma moeda",
            alert_must_enter_value_currency: "Deve inserir o valor da moeda",

            alert_need_to_login_again: "Você precisa fazer login novamente",
            alert_must_select_marca: "Deve selecionar a marca",

            alert_must_choose_document: "Deve selecionar o documento",
            alert_types_allowed: "Apenas arquivos JPG, PNG e PDF são permitidos",

            alert_only_5_mb_allow: "O tamanho do arquivo excede o limite de 5MB",

            alert_passwords_do_not_match: "Senha não coincide",

            alert_procesado_correctamente: "Processado com sucesso",
            alert_no_se_pudo_processar: "Não se conseguiu processar",
            alert_must_enter_amount: "Você deve inserir o valor",
            alert_must_select_estado_pago: "Você deve selecionar o status 'Pago'",
            alert_debe_ingresar_nombre_empresa: "Você deve inserir o nome da empresa",
            alert_debe_ingresar_telefono_empresa: "Você deve inserir o telefone da empresa",
            alert_debe_ingresar_email_empresa: "Você deve inserir o email da empresa",
            alert_debe_seleccionar_timezone: "Você deve selecionar o fuso horário",
            alert_no_se_pudo_validar_nombre_empresa: "Não foi possível validar o nome da empresa",
            alert_nombre_empresa_ya_existe: "O nome da empresa já existe",
            alert_debe_ingresar_usuario: "Você deve inserir o usuário",
            alert_debe_ingresar_password: "Você deve inserir a senha",
            alert_debe_ingresar_confirmar_password: "Você deve inserir a confirmação da senha",
            alert_passwords_no_coinciden: "As senhas não coincidem",

            placeholder_enter_sub_group: "Digite o nome do subgrupo",

            title_manage_type_fuel: "GERENCIAR TIPO DE COMBUSTÍVEL",
            title_manage_provider: "GERENCIAR OPERADORA MÓVEL",
            title_manage_vehicle_model: "GERENCIAR MODELO DE VEÍCULO",
            title_manage_marca: "GERENCIAR MARCA",
            title_manage_equipment_provider: "GERENCIAR FORNECEDOR DE EQUIPAMENTOS",
            title_manage_companies: "GERENCIAR EMPRESAS",
            title_manage_users: "GERENCIAR USUÁRIOS",
            title_manage_group: "GERENCIAR GRUPO",
            title_manage_sub_group: "GERENCIAR SUBGRUPO",
            title_manage_tipo_vehiculo: "GERENCIAR TIPO DE VEÍCULO",
            title_manage_battery_voltage: "GERENCIAR VOLTAGEM DA BATERIA",
            title_manage_vehicle_traction: "GERENCIAR TRAÇÃO DO VEÍCULO",
            title_manage_installation: "GERENCIAR INSTALAÇÃO",
            title_manage_installation_by_company: "GERENCIAR INSTALAÇÃO POR EMPRESA",
            title_manage_sim: "GERENCIAR SIM",
            title_manage_cliente_secundario: "GERENCIAR CLIENTE SECUNDÁRIO",
            title_restore_password: "RESTAURAR SENHA",
            title_manage_equipment_tracking: "GERENCIAR RASTREADOR",
            title_manage_sellers: "GERENCIAR VENDEDORES",
            title_info_vehicle: "INFORMAÇÕES DO VEÍCULO",
            title_aditional_information: "INFORMAÇÕES ADICIONAIS",
            title_aditional_custom: "PERSONALIZAÇÃO ADICIONAL",
            title_users_companies: "USUÁRIOS DA EMPRESA",
            title_manage_vehicle: "GERENCIAR VEÍCULOS",
            title_manage_currency: "GERENCIAR MOEDA",
            title_manage_config_excel: "GERENCIAR CONFIGURAÇÃO EXCEL",
            title_manage_import: "GERENCIAR IMPORTAÇÃO",
            title_manage_vehicle_documents: "GERENCIAR DOCUMENTOS DO VEÍCULO",
            title_aditional_documents: "ADICIONAR DOCUMENTOS",
            title_eventos: "LISTA DE EVENTOS",
            title_registrar_empresa: "REGISTRAR EMPRESA",
            title_datos_cobranza: "DADOS DE COBRANÇA",

            estado_pago_mora: "EM ATRASO",
            estado_pago_pagado: "LIQUIDADO",

            tipo_servicio_propio: "SERVIÇO PRÓPRIO",
            tipo_servicio_alquiler: "SERVIÇO DE ARRENDAMENTO",
        },
    }
};

i18n
    .use(initReactI18next) // Passes i18n instance to react-i18next
    .init({
        resources,
        lng: "en", // Set default language
        fallbackLng: "en", // Fallback if the selected language isn't available
        interpolation: {
            escapeValue: false, // React already escapes values
        },
    });

export default i18n;
